import api from "../../index";
import { GetTeamMemberListApi } from "../team/team";

export const GetTaskListApi = () => api.post('emp-business-task-list');
export const GetEmployeeListApi = () => GetTeamMemberListApi();
export const AssignTaskApi = (data) => api.post('assign-business-org-task', data);